import { useUser, useAuth as useClerkAuth, useClerk } from "@clerk/clerk-react";
import { getQueryFn } from "@/lib/queryClient";
import { useAuthCore } from "@scroll/shared-hooks";
import type { User as BaseUser } from "@scroll/shared-types";

/** Auth user augmented with streak fields the API merges in from `user_streaks`. */
export type AuthUser = BaseUser & {
  currentStreak?: number;
  lastPostDate?: string | null;
};

export function useAuth() {
  const { isSignedIn, isLoaded } = useClerkAuth();
  const { user: clerkUser } = useUser();
  const { signOut } = useClerk();

  const core = useAuthCore({
    isSignedIn,
    isLoaded,
    clerkUserId: clerkUser?.id,
    clerkUsername: clerkUser?.username,
    clerkFullName: clerkUser?.fullName,
    clerkImageUrl: clerkUser?.imageUrl,
    clerkEmail: clerkUser?.primaryEmailAddress?.emailAddress,
    queryFn: getQueryFn({ on401: "returnNull" }),
  });

  return {
    user: core.user as AuthUser | null,
    clerkUser,
    isLoading: core.isLoading,
    isAuthenticated: core.isAuthenticated,
    signOut,
  };
}
